import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DownArrow12 = (props: SvgProps) => <Svg
  width="13"
  height="14"
  viewBox="0 0 13 14"
  fill="none"
  {...props}
>
  <Path
    d="M6.5 10.6562L6.5 3.34375"
    stroke="#005F09"
    strokeMiterlimit="10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <Path
    d="M3.65625 7.8125L6.5 10.6562L9.34375 7.8125"
    stroke="#005F09"
    strokeMiterlimit="10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</Svg>;

export default DownArrow12;
